import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  const features = ['Formularios imprimibles y digitales', 'Protocolos basados en evidencia actualizada', 'Adaptado 100% al contexto argentino 2025', 'Normativa argentina vigente (Leyes 26.529 · 27.642)', 'Listo para usar desde la primera consulta'];
  return <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto text-center relative" data-id="element-326">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-green-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-327"></div>

      <FadeIn data-id="element-328">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block mb-3 md:mb-8 relative" data-id="element-329">
          <div className="absolute inset-0 bg-yellow-500/20 blur-2xl rounded-full" data-id="element-330"></div>
          <span className="text-5xl md:text-8xl relative z-10 drop-shadow-[0_0_30px_rgba(234,179,8,0.5)]" data-id="element-331">
            🏆
          </span>
        </motion.div>

        <h2 className="text-3xl md:text-7xl font-black mb-3 md:mb-8 text-transparent bg-clip-text bg-gradient-to-b from-white via-green-100 to-green-500 tracking-tight drop-shadow-lg" data-id="element-332">
          MEGAPACK NUTRICIONISTA LISTA™
        </h2>

        <p className="text-base md:text-4xl font-bold text-gray-300 mb-6 md:mb-14 max-w-3xl mx-auto leading-tight px-2" data-id="element-333">
          6 Tomos + 6 Bonos · Todo resuelto. Todo argentino. Todo listo.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-334">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl md:rounded-3xl p-5 md:p-12 max-w-3xl mx-auto text-left shadow-[0_0_40px_rgba(34,197,94,0.1)] relative overflow-hidden" data-id="element-335">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-600 via-green-400 to-green-600" data-id="element-336"></div>

          <ul className="space-y-3 md:space-y-6 relative z-10" data-id="element-337">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex items-center gap-3 md:gap-4" data-id="element-338">
                <div className="bg-green-500/10 p-1.5 md:p-2 rounded-full border border-green-500/20 shrink-0" data-id="element-339">
                  <CheckCircle2 className="text-green-500 w-5 h-5 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-340" />
                </div>
                <span className="text-sm md:text-2xl text-gray-200 font-medium" data-id="element-341">
                  {feature}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}